// extracted by mini-css-extract-plugin
module.exports = {"anchor":"Testimonials_anchor__2QGu3","sectionContainer":"Testimonials_sectionContainer__emQi5"};